module.exports = __webpack_public_path__ + "files/de17307e473c525e477dcf6a7fb55f4d.png";